import { render, staticRenderFns } from "./cargoGridShowBigContent.vue?vue&type=template&id=5438dad2&scoped=true&"
import script from "./cargoGridShowBigContent.vue?vue&type=script&lang=js&"
export * from "./cargoGridShowBigContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438dad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5438dad2')) {
      api.createRecord('5438dad2', component.options)
    } else {
      api.reload('5438dad2', component.options)
    }
    module.hot.accept("./cargoGridShowBigContent.vue?vue&type=template&id=5438dad2&scoped=true&", function () {
      api.rerender('5438dad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/grid/cargoGridShowBigContent.vue"
export default component.exports